export const FilesSidebarTitle = {
  IconButton_arrow: {},
  Span: {},
  'NavbarButton.add': {
    transition: 'A defaultBezier opacity',
    color: 'disabled',
    title: (el) => el.call('polyglot', 'editor.sidebar.addNew'),
    icon: 'plus',
    fontSize: 'Z2',
    allowedAddNewDropdown: [
      'components',
      'pages',
      'functions',
      'methods',
      'snippets',
      'typography',
      'state'
    ],
    allowedAddNewPanel: ['semantic_color', 'color', 'theme', 'media', 'icons', 'media', 'spacing'],
    allowedAddModal: ['font', 'font_family', 'templates', 'cases', 'dependencies', 'files'],
    hide: (el, s) => {
      const activeFileSidebar = el.call('getActiveDynamicIslandCategory')
      return (
        !el.hasProjectPermission('editMode') ||
        activeFileSidebar !== 'Local' ||
        (!el.allowedAddNewDropdown.includes(s.type) &&
          !el.allowedAddNewPanel.includes(s.type) &&
          !el.allowedAddModal.includes(s.type))
      )
    },
    margin: '- - - auto',
    onClick: async (ev, el, s) => {
      ev.stopPropagation()
      ev.preventDefault()
      el.call('setCookie', `sidebar_${s.type}`, true)

      if (el.allowedAddNewDropdown.includes(s.type)) {
        s.toggle('adding')
        // LOOKUP-SHAPE-1: this five-deep chain used to deref unguarded
        // INSIDE a setTimeout — a miss at any link threw into nothing (no
        // error surface, no user feedback), so the focus just silently
        // never happened. Guarded link-by-link; a miss now no-ops instead
        // of throwing into the timer.
        return setTimeout(() => {
          const list = el.lookup('FilesSidebarList')
          const addNewItem = list?.parent?.lookdown('FileSidebarAddNewItem')
          const input = addNewItem?.Label?.Input
          input?.node?.focus()
        }, 100)
      }

      if (el.allowedAddNewPanel.includes(s.type)) {
        return el.call('setFloatingPanel', {
          type: el.call('getSingular', s.type),
          key: '',
          value: null
        })
      }

      await el.call('openModal', `/add-${el.getSingular(s.type.replace(/_/gu, '-'))}`)
    }
  },
  'NavbarButton.sort': {
    transition: 'A defaultBezier opacity',
    color: 'disabled',
    title: (el) => el.call('polyglot', 'editor.sidebar.sortAz'),
    icon: (el, s) => {
      const value = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true'
      return value ? 'textLineHeight' : 'language'
    },
    fontSize: 'Z2',
    hide: (el, s) => {
      return !['components', 'pages', 'files', 'state', 'functions', 'methods'].includes(s.type)
    },
    onClick: async (ev, el, s) => {
      ev.stopPropagation()
      ev.preventDefault()
      const value = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true'
      el.call('setCookie', `sidebar_${s.type}_sort`, !value)
      s.update()
    }
  },
  'NavbarButton.question': {},
  extends: ['FilesSectionTitle']
}
